// extracted by mini-css-extract-plugin
export default {"iconSvg":"IconLocationPin_iconSvg__EjyuD","iconSvgGroup":"IconLocationPin_iconSvgGroup__oK6S9"};